/**
 * The exhibit letter for a position, A, B, … Z, AA, AB.
 *
 * Mirrors `exhibitLetter` in `backend/src/templates/merge-fields/resolvers/
 * exhibit.resolvers.ts`, which is what the rendered document actually uses. The
 * two are a genuine duplicate of one rule, and this copy exists only so the
 * lawyer sees the letter *before* generating; the backend's is authoritative for
 * every letter that reaches a document.
 *
 * It lives here rather than beside either caller because there are now two
 * surfaces that letter exhibits ahead of a render — the Documents tab's generate
 * drawer and the composer's attach-a-precedent picker — and a second in-file
 * copy would be a third definition of a rule that already has one too many.
 */
export function exhibitLetter(index: number): string {
  let letter = '';
  let remaining = index;
  do {
    letter = String.fromCharCode(65 + (remaining % 26)) + letter;
    remaining = Math.floor(remaining / 26) - 1;
  } while (remaining >= 0);
  return letter;
}
